import { render, staticRenderFns } from "./punkt-block.vue?vue&type=template&id=686a1b9c"
import script from "./punkt-block.vue?vue&type=script&lang=ts"
export * from "./punkt-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports